let resolveGoogleMapsApi: (maps: typeof google.maps) => void;
let rejectGoogleMapsApi: (error: unknown) => void;

const googleMapsApi = new Promise<typeof google.maps>((resolve, reject) => {
    resolveGoogleMapsApi = resolve;
    rejectGoogleMapsApi = reject;
});

// pages without a map never wait on the API, so a failed load must not surface as an unhandled rejection
googleMapsApi.catch(() => {});

/**
 * Resolves `loadGoogleMapsApi()` once `GoogleMapsApiProvider` has loaded the API
 */
export const onGoogleMapsApiLoad = () => {
    resolveGoogleMapsApi(window.google.maps);
};

/**
 * Rejects `loadGoogleMapsApi()` when `GoogleMapsApiProvider` fails to load the API or a library
 *
 * `google-map-react` then finishes initializing the map without the API
 */
export const onGoogleMapsApiError = (error: unknown) => {
    console.error('The Google Maps JavaScript API failed to load.', error);
    rejectGoogleMapsApi(error);
};

/**
 * Waits for the `google.maps` namespace loaded by `GoogleMapsApiProvider`
 *
 * Passed as `googleMapLoader` to `google-map-react` so it reuses this API instead of loading its own
 */
export const loadGoogleMapsApi = () => googleMapsApi;
